export default __webpack_public_path__ + "static/media/son.a065007f.svg";